import { memo } from 'react';
import Coupon from '../Coupon';
import { useForm } from '../context';
import DetailsCollapse from './DetailsCollapse';
import OpenValueInput from './OpenValueInput';
import PricingSummary from './PricingSummary';
import ProductInfo from './ProductInfo';
import { useHeaderPricing } from './useHeaderPricing';

const Header = memo(() => {
  const { firstItem } = useForm();
  const pricing = useHeaderPricing();

  const isOpenValue = firstItem?.config?.isOpenValue;
  const minAmount = firstItem?.config?.openValueMinAmount;
  const maxAmount = firstItem?.config?.openValueMaxAmount;

  return (
    <div>
      <ProductInfo firstItem={firstItem}>
        {isOpenValue && (
          <OpenValueInput
            firstItem={firstItem}
            minAmount={minAmount}
            maxAmount={maxAmount}
            isRecurrence={pricing.isRecurrence}
          />
        )}

        {!isOpenValue && (
          <PricingSummary
            firstItem={firstItem}
            isRecurrence={pricing.isRecurrence}
            totalValue={pricing.totalValue}
            maxInstallment={pricing.maxInstallment}
            installmentValue={pricing.installmentValue}
            totalDiscountAmount={pricing.totalDiscountAmount}
            hasOrderBump={pricing.hasOrderBump}
            enrollmentFee={pricing.enrollmentFee}
            getTotal={pricing.getTotal}
          />
        )}

        <Coupon />
      </ProductInfo>

      {firstItem?.details && <DetailsCollapse details={firstItem.details} />}
    </div>
  );
});

Header.displayName = 'Header';

export default Header;
